export async function fetcher(url: string, options: RequestInit): Promise<Response> {
    return await fetch(url, options);
}

let apiUrl = "https://api.pka-ejendomme.dk";

export function initFetcher() {
    const json = document.querySelector("script#cfg")?.innerHTML;
    if (!json) {
        return;
    }

    const { api } = JSON.parse(json);
    if (api) {
        apiUrl = api;
    }
}

export function getApiUrl() { return apiUrl; }
